import React from "react";
import PatientCard from "../../Patient/partial/PatientCard";
import StaffProfileCard from "../../Staff/partials/StaffProfileCard";

const AppointmentSummary = ({ model }) => {
	return (
		<div className="col-md-4 col-xs-12">
			<div>
				<div className="card">
					<div className="card-head">
						<header>Patient</header>
					</div>
					<div className="card-body">
						<PatientCard item={model.patient} />
					</div>
				</div>
				<div className="card">
					<div className="card-head">
						<header>Current Assignee</header>
					</div>
					<div className="card-body">
						<StaffProfileCard item={model.assignee} />
					</div>
				</div>
				<div className="card">
					<div className="card-head">
						<header>Quick Summary </header>
					</div>
					<div className="card-body">
						<h4>Note</h4>
						<p>{model.note}</p>
						<h5>Appointment Date</h5>
						<p>
							{Intl.DateTimeFormat("en-GB", {
								weekday: "short",
								month: "short",
								year: "numeric",
								day: "numeric"
							}).format(new Date(parseInt(model.date)))}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AppointmentSummary;
